import { graphQlClient } from '@config/graphqlClient';
import {
  CreateLineItemInput,
  UpdateLineItemInput,
  ProjectBudgetSummary,
} from '@models/lineItem.model';
import LineItemGraphQL from '@graphql/lineItem.queries';

export const lineItemService = {
  async getProjectBudgetSummary(projectId: string): Promise<ProjectBudgetSummary> {
    const data: any = await graphQlClient.request(
      LineItemGraphQL.queries.getProjectBudgetSummary,
      { projectId },
    );
    return data?.getProjectBudgetSummary;
  },

  async getDistinctUnitsOfMeasure(): Promise<string[]> {
    const data: any = await graphQlClient.request(
      LineItemGraphQL.queries.getDistinctLineItemUnitsOfMeasure,
    );
    return data?.getDistinctLineItemUnitsOfMeasure ?? [];
  },

  async createLineItem(input: CreateLineItemInput) {
    const data: any = await graphQlClient.request(
      LineItemGraphQL.mutations.createLineItem,
      { input },
    );
    return data?.createLineItem;
  },

  async updateLineItem(input: UpdateLineItemInput) {
    const data: any = await graphQlClient.request(
      LineItemGraphQL.mutations.updateLineItem,
      { input },
    );
    return data?.updateLineItem;
  },

  async deleteLineItem(lineItemId: string) {
    const data: any = await graphQlClient.request(
      LineItemGraphQL.mutations.deleteLineItem,
      { lineItemId },
    );
    return data?.deleteLineItem;
  },
};
